jQuery(function($) {

   /* VAR */
   var LARGEUR_MAX_MOBILE = 700; /* PODOM */
   var top_header = $('#masthead');
   var h_top_header = top_header.height();
   var admin_bar_h = 0;

   if($('body').hasClass('admin-bar')){
      admin_bar_h = 32;
   }


 
      //  WOW EFFECT //
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       true,       // trigger animations on mobile devices (default is true)
        live:         false,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null // optional scroll container selector, otherwise use window
      }
    );
   wow.init();
   


  /* **************************************************  */
  /* NICSELECT */
  /* **************************************************  */
  $('.to_nicedropdown-js').niceSelect();

  $('.js-special_sub_menu_mobile').on('change', function() {
      $('.TypeDesktop li a[data-filter="'+this.value+'"]').trigger( "click" );
      $('.to_nicedropdown-js').toggleClass('open');  
  });

  $('.js-special_go_to_page').on('change', function() {
     var href = this.value;
     document.location = href;
  });


     /* *****************  */
    /* CONTACT FORM 
  /* *****************  */

  // Formulaire de contact ///
   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form input[type='tel'], .wpcf7-form select" ).click(function() {
      $( this ).parent().parent().addClass('focus');
  });

    $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form input[type='tel'], .wpcf7-form select" ).blur(function() {
      if($(this).val()  === '') $( this ).parent().parent().removeClass('focus');
  });

    $( ".wpcf7-form label" ).click(function() {
      $( this ).parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form input[type='tel'],.wpcf7-form textarea, .wpcf7-form select" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='tel'],.wpcf7-form input[type='text'],.wpcf7-form textarea, .wpcf7-form select" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });


   /* *****************  */
    /* SUBMENU-REFERENCE 
  /* *****************  */


    if($("#submenu-js").length){
      var position_top_sub_menu = $("#submenu-js").offset().top;
    }
     //  $( window ).resize(function() {
    //      position_top_sub_menu = $("#submenu-js").offset().top;
    // });
    if($('#submenu-js').length){
      $(window).scroll(function () {
        action_on_scroll_sub_menu();
      });
    }



  function active_fixed_sub_menu(){
    $("body").addClass('to_fixed_sub_menu'); 
  }

  function remove_fixed__sub_menu(){
    $("body").removeClass('to_fixed_sub_menu');
  }

  function action_on_scroll_sub_menu(){

       if ($(window).scrollTop() > position_top_sub_menu - h_top_header - admin_bar_h){
          active_fixed_sub_menu();
        }else{
          remove_fixed__sub_menu();
        }
 }






    /*************/
      /* LOADER PAGE !  */
    /*************/

 // jQuery(window).load(function() {
    loader_finish();
 // }) ;
   //
 function loader_finish(){
    //console.log('fini');
   // window.setTimeout(attente_loader_finish,0);
    anim_loader_to_insivisble();
  }

  function attente_loader_finish(){
     //$('#loader_page').addClass('to_load');
    // window.setTimeout(anim_loader_to_insivisble,0);
       //loader.addClass("to_transition");
  }
  function anim_loader_to_insivisble(){

    $('body').addClass('load_page');

     window.setTimeout(fin_loader,1000);
  }

  function fin_loader(){
    $('body').removeClass('load_page');
  }

    /*************/
      /* FIN LOADER !  */
    /*************/



  /******************************************/
    /********** SCROLL - NAV -----------/
  /******************************************/
 $(window).scroll(function () {
      action_on_scroll();
  });

  
  function action_on_scroll(){
    var l_window = parseInt($(window).width());
    h_top_header = top_header.height();

    if (l_window > LARGEUR_MAX_MOBILE){
       if ($(window).scrollTop() > h_top_header){
        $("body").addClass('header--sticky');
        }else{
            $("body").removeClass('header--sticky');
        }
    }else{

        if ($(window).scrollTop() > 0){
          $("body").addClass('header--sticky');
              }else{
                $("body").removeClass('header--sticky');
              }
      }
   }


  /* *****************  */
    /* SMOOTH SCROLL :  INTRO AUTRE PAGE  */
  /* *****************  */

      var menuItems = $('.ToBottom-btn-page');
      var offsetTop;
    menuItems.click(function(e){

      var href = $(this).attr("href"),
          offsetTop = href === "#" ? 0 : $(href).offset().top-h_top_header - 20;
    
               $('html, body').stop().animate({ 
              scrollTop: offsetTop
          }, 800);
       
        e.preventDefault();
    });





   /* *****************  */
    /* CLICK MENU BTN
  /* *****************  */

   var ContainAllMenuSvg = SVG('ContainAllMenu--svg');
//   var mask_forme_menu_svg = ContainAllMenuSvg.select('path.mask_forme_svg');

   var h_window,l_window, middle_hmiddle_h_courbe, l_296,l_565,l_246,l_533;

    function init_size_svg_transition(){
     h_window = $(window).height();
     l_window = parseInt(($(window).width() / 4)); // podom - / 4 plutot que 2  (pour faire moins en pointe)
     middle_h = parseInt(h_window / 2);
     quart_h_courbe = parseInt(h_window / 6 ); // podom / 6 plutôt que 4 (pour faire moins en pointe)

     l_246 = parseInt((h_window * 246) / 1080);
     l_296 = parseInt((h_window * 296) / 1080);
     l_565 = parseInt((h_window * 565) / 1080);
     l_533 = parseInt((h_window * 533) / 1080);
     middle_plus_courbe = parseInt(1.1*l_533);
 
     $("#ContainAllMenu--svg").width(l_window).height(h_window); // size sur le svg 
   }

   init_size_svg_transition();
   $(".ContainAllMenu--svg .mask_forme_svg").attr('d','M0,'+h_window+'c0,0,'+l_window+'-'+quart_h_courbe+','+l_window+'-'+middle_h+'C'+l_window+','+parseInt(quart_h_courbe+5)+',0,0,0,0S-57,'+l_533+',0,'+h_window+'z');
   var mask_forme_menu_svg = ContainAllMenuSvg.path('M0,'+h_window+'c0,0,'+l_window+'-'+quart_h_courbe+','+l_window+'-'+middle_h+'C'+l_window+','+parseInt(quart_h_courbe+5)+',0,0,0,0S-57,'+l_533+',0,'+h_window+'z').fill('#fa0026');
   
   $( window ).resize(function() {
      init_size_svg_transition();
  });

  
   $("#menu-toggle").click(function(e){
      if($(this).attr('aria-expanded') == 'true'){
        $('body').addClass('open_menu');
        console.log('h_window = '+ h_window);
          // M0,1080c0,0-11-296.832-11-565C-11,246,0,0,0,0S-57,533,0,1080z
           mask_forme_menu_svg.stop().animate(2000, 'backOut',0).plot('M0,'+h_window+'c0,0-11-'+l_296+'-11-'+l_565+'C-11,'+l_246+',0,0,0,0S-57,'+l_533+',0,'+h_window+'z'); // podom 2000 au lieu de 1500

      }else{
         $('body').removeClass('open_menu');
          mask_forme_menu_svg.stop().animate(0, '-',0).plot('M0,'+h_window+'c0,0,'+l_window+'-'+quart_h_courbe+','+l_window+'-'+middle_h+'C'+l_window+','+parseInt(quart_h_courbe+5)+',0,0,0,0S-57,'+l_533+',0,'+h_window+'z');
      }
   });


  var button_open_brief = $('.js-aside-goodies');
  var BlockGoodies = $('.Goodies');
  var CacheOpen = $('.Goodies-Cache');

  var l_852 = 852;
  // var block_aside_inner = $('.Register-Block');
  // if(l_window < LARGEUR_MAX_MOBILE+1){
  //   block_aside_inner.hide();
  // }
  button_open_brief.click(function() {
    l_window = parseInt($(window).width());
     if($(this).attr('aria-expanded') == 'false'){
        BlockGoodies.addClass('to_open');
        CacheOpen.addClass('to_open').fadeIn(500);
        $(this).attr('aria-expanded', 'true');
        $(this).addClass('to_close');

     }else{
        BlockGoodies.removeClass('to_open');
        CacheOpen.fadeOut(500, function(){$(this).removeClass('to_open');});
        $(this).attr('aria-expanded', 'false');
        $(this).removeClass('to_close');
     }
  });


   $('.js-open_goodies_bloc').click(function(e) {

      if(button_open_brief.attr('aria-expanded') == 'false'){
        BlockGoodies.addClass('to_open');
        CacheOpen.addClass('to_open').fadeIn(500);
        button_open_brief.attr('aria-expanded', 'true');
        button_open_brief.addClass('to_close');

     }else{
        BlockGoodies.removeClass('to_open');
        CacheOpen.fadeOut(500, function(){button_open_brief.removeClass('to_open');});
        button_open_brief.attr('aria-expanded', 'false');
        button_open_brief.removeClass('to_close');
     }

    e.preventDefault();

  });


  

   var ButtonCloseBrief = $('.Goodies-Cache');
   ButtonCloseBrief.click(function() {
      CacheOpen.fadeOut(500, function(){$(this).removeClass('to_open');});
      BlockGoodies.removeClass('to_open');
      button_open_brief.attr('aria-expanded', 'false');
      button_open_brief.removeClass('to_close');
   });


  /*************/
    /* SCROLLBAR - BREVES */
  /*************/


  if($('.myscrollbar').length){
    var el = document.querySelector('.myscrollbar');
    SimpleScrollbar.initEl(el);
  } 






    $("#primary-menu a,a.js-add-loader").click(function(evt){

        load_anim();

        var link = $(this).attr("href");
        setTimeout(function() {
            window.location.href = link;
        }, 1350);

        evt.preventDefault();
    });


	  // var mySvg_mask = SVG('mask_1');
	  // var mySvg_mask2 = SVG('mask_2');

   //  var mask_top = mySvg_mask.select('path.mask_forme');
   //  var mask_coeur = mySvg_mask2.select('path.mask_coeur');

   //  var circle = mySvg_mask.circle(100);
    
         // DOC HERE : 

  function load_anim(){
      $( "body" ).addClass('to_transition');

      // https://github.com/svgdotjs/svg.easing.js
 // NO     mask_top.stop().animate(500, 'backOut',0).plot('M957.091,687.083c-436.667,0-809.513-75.144-956.952-113.378v503.358h1919.903V572.11C1776.924,611.182,1399.807,687.083,957.091,687.083z').animate(400, 'backIn',-100).plot('M987-15C550.333-15,127-29,0,0v1080h1920l0.042-1080C1777-27,1429.716-15,987-15z');

      // STEP 1 - Jusqu'à la courbe   mask_top.stop().animate(600, 'elastic',100).plot('M957.091,687.083c-436.667,0-809.513-75.144-956.952-113.378v503.358h1919.903V572.11C1776.924,611.182,1399.807,687.083,957.091,687.083z')
      // STEP 2  -jus'au dessus mask_top.stop().animate(400, 'backIn',0).plot('M987-15C550.333-15,127-29,0,0v1080h1920l0.042-1080C1777-27,1429.716-15,987-15z'); // forme vague milieu
      

  }



  function to_reset_anim(){
    $('body').removeClass('remove_coeur to_transition to_transition_load');
    // mask_top.fill('#fa0026');
    // mask_coeur.fill('#fff').opacity(1);
  }

 

    /*************/
      /* REFERENCES !  */
    /*************/

    /*************/
      /* ISOTOPE + MASONRY _ PROJETS */
    /*************/

 var $grid = $('.grid-container').imagesLoaded( function() {

    var FilterInit = $('.grid-container').attr('data-filter-init');
    
      $grid.isotope({
      itemSelector: '.grid-item',
      percentPosition: true,
      layoutMode: 'fitRows',
      filter: FilterInit,
      fitRows: {
        // use outer width of grid-sizer for columnWidth
        columnWidth: '.gridpost-sizer',
        gutter: '.gridpost-gutter-sizer'
      }
    });
  });

  /*************/
      /* FILTRE PAR TYPES */
    /*************/
  $('.page-template-m_references .TypeDesktop a').on( 'click', function(evt) {
    
      var newOffsetTop =  h_top_header - 20;
    
          $('html, body').stop().animate({ 
              scrollTop: newOffsetTop
          }, 800);
       

    

    var filterValue = $(this).attr('data-filter');
    $grid.isotope({ filter: filterValue });
    $('.TypeDesktop li').removeClass('current');
    $(this).parent().addClass('current');

    evt.preventDefault();
  });

    
 });